import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pb-2.5 font-bold em88:pt-2.5" }
const _hoisted_2 = ["href"]

import ListItem from "./ListItem.vue";
import { typeAheadItems } from "@/composables/use-search";

export default /*#__PURE__*/_defineComponent({
  __name: 'FindingsClassic',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeAheadItems), (typeAheadItem, i) => {
    return (_openBlock(), _createElementBlock("div", {
      key: `typeAhead-${i}`,
      class: "mb-4 border-b border-b-gray-40 pb-3 last:mb-0 last:border-b-0 last:pb-0"
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(typeAheadItem.headline), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeAheadItem.entries, (entry, j) => {
        return (_openBlock(), _createElementBlock("a", {
          key: `typeAheadEntry-${j}`,
          href: entry.link,
          class: "-mx-4 block px-4 font-normal hover:bg-gray-20"
        }, [
          _createVNode(ListItem, {
            text: entry.content
          }, null, 8, ["text"])
        ], 8, _hoisted_2))
      }), 128))
    ]))
  }), 128))
}
}

})